import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import suitcss from '../../../helpers/suitcss';
import Copy from '../../basics/text/TextCopy';
import connectUI from '../../basics/ui/UIConnector';
import Accordion from '../../basics/accordion/Accordion';

const componentName = 'CheckoutCartFaqFooter';
const CheckoutCartFaqFooter = ({
  ui,
  faqs = [],
  stepId,
}) => {
  const stepFaqs = stepId ? faqs && faqs.filter(faq => faq.id.endsWith(stepId)) : faqs;
  return (
    <div className={suitcss({ componentName, descendantName: 'faqs' })}>
      {stepFaqs.map(faq => (
        <Accordion
          title={ui.cfoFaqHeadline}
          hash={faq.id}
          forceOpen
          key={faq.id}
          elementName="faqFooter"
          titleElement="h2"
        >
          {faq.entries.map((entry) => (
            <Accordion
              title={entry.question}
              hash={entry.id}
              open={entry.expanded || false}
              key={entry.id}
            >
              <Copy size="small" embedded raw>{entry.answer}</Copy>
            </Accordion>
          ))}
        </Accordion>
      ))}
    </div>
  );
};

CheckoutCartFaqFooter.propTypes = {
  stepId: PropTypes.string,
  faqs: PropTypes.array,
  ui: PropTypes.object.isRequired,
};

export default compose(
  connectUI(),
)(CheckoutCartFaqFooter);
